<template>
  <!--问题-->
  <div class="qa-list">
    <div class="list-item" v-for="(item, index) in qa">
      <div class="q">
        <div class="num">{{index + 1}}</div>{{item.q}}
      </div>
      <div class="a" v-html="item.a"></div>
    </div>
    <!--查看更多问题按钮-->
    <!--<tk-flex center class="m-t-20">
      <div class="qa-btn">查看更多问题</div>
    </tk-flex>-->
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    qa: {
      type: Array
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  /*问题样式*/
  .qa-list {
    width: 100%;
    padding: 0 15px;
    margin-top: -10px;
    .list-item {
      padding: 20px 0 15px;
      border-bottom: 1px solid #e5e5e5;
      font-weight: bold;
      page-break-inside: avoid;
      .q {
        padding: 12px 0;
        line-height: 20px;
        font-size: 14px;
        color: #43439f;
        .num {
          display: inline-block;
          vertical-align: bottom;
          width: 20px;
          height: 20px;
          font-size: 12px;
          line-height: 20px;
          color: white;
          text-align: center;
          margin-right: 8px;
          border-radius: 50%;
          background: #43439f;
        }
      }
      .a {
        line-height: 180%;
        font-size: 14px;
        color: #2d2d49;
      }
    }
    .qa-btn {
      width: 95px;
      height: 27px;
      border: 1px solid #43439F;
      background-color: #ffffff;
      line-height: 27px;
      text-align: center;
      font-size: 12px;
      color: #43439f;
    }
  }
</style>
